import React, {useState, useEffect, useRef} from 'react';
import './ActionItemCreate.css';
import { useCTAL } from './CTAL_Hooks.js';

const DEBUG = false;

export default function ActionItemCreate({show_display}) 
{
    const { app_user, team_id, team, action_item_list_display, setActionItemShortListRefresh, setActionItemLongListRefresh, setActionItemTeamListRefresh,
            setActionItemShortListCountRefresh, setActionItemLongListCountRefresh, setNewActionItemFlag } = useCTAL();

    const [new_action_placeholder, setNewActionPlaceHolder] = useState("New Action Title");
    const [user_message, setUserMessage] = useState(<></>);
    const [result, setResult] = useState();
    const [loading, setLoading] = useState();
    const [error, setError] = useState();
    const initRef = useRef("");

    const setup_event_listener = () => { 
        if (initRef.id == "DONE") return;
            initRef.id = "DONE";

        if (DEBUG) console.log(`ActionItemCreate**** - setup_event_listener: Enter`);

        var input = document.getElementById("new-action-item-summary");

        input.addEventListener("keypress", function(event) {
            if (event.key === "Enter") {
                event.preventDefault();
                document.getElementById("create-action-item-btn").click(); 
            }
        });
    }

    useEffect(() =>
    {
        setup_event_listener();
    }, []); //only run once

    useEffect(() =>
    {
        if (team) setNewActionPlaceHolder(`New ${team.TeamName} Action Title`);
        else setNewActionPlaceHolder(`New Private Action Title`);
    }, [team]); 
 
    const refresh_action_item_list = () => { 
        //console.log(`ActionItemCreate**** - refresh_action_item_list, action_item_list_display: ${action_item_list_display}`);
        
        show_display("action-item-list"); //Make sure we're showing Action Item List
        setNewActionItemFlag(true); //Let's make sure we display the newly created AI in the Detail Display
        
        switch(action_item_list_display)
        {
            case "team-display":
            case "team-assigned-display":
                setActionItemTeamListRefresh(true);
                break;
            case "user-short-list-display":
                setActionItemShortListRefresh(true);
                setActionItemShortListCountRefresh(true);
                break;
            case "user-long-list-display":
                setActionItemLongListRefresh(true);
                setActionItemLongListCountRefresh(true);
                break;
            case "user-app-admin-display":
            default:
                return;
        }
    }

    const validate_and_create_action_item = () => { 
        var summary = document.getElementById("new-action-item-summary").value;

        if ((!summary) || (summary.length == 0))
        {
            if (app_user.UserName == "authorwjf")
                setUserMessage(<div id="user-message" className="mb-0 ms-2"><small>Again Bill? Please Enter a New Action Summary</small></div>);
            else
                setUserMessage(<div id="user-message" className="mb-0 ms-2"><small>Please Enter a New Action Summary</small></div>);
            return;
        }

        setUserMessage(<></>);
        create_action_item();
    }

    const create_action_item = () => { 
        var type = "create_action_item";
        var create_user_id = app_user.UserID;
        var assigned_user_id = ""; 
        var input_element = document.getElementById("new-action-item-summary");
        var summary = input_element.value;

        var is_private = true;
        if ((action_item_list_display == "team-display") || (action_item_list_display == "team-assigned-display"))
            is_private = false; //Team Action-Items are NOT private

        //assigned_user_id is empty except if this is the ShortList, then set to app_user.UserID
        if (action_item_list_display == "user-short-list-display")
            assigned_user_id = app_user.UserID;

        var set_body = JSON.stringify({type, team_id, create_user_id, assigned_user_id, summary, is_private});
         
        //console.log(`ActionItemCreate - team_id: ${team_id}, UserID: ${app_user.UserID}, summary: ${summary}`);

        console.log(`ActionItemCreate - Creating new Action Item via ctal-set for: ${team_id}`);
        //SSS-FUNC fetch(`https://cpcsaczyec.execute-api.us-east-1.amazonaws.com/ctal-set`, { method: "POST", body: set_body })
        fetch(`https://cpcsaczyec.execute-api.us-east-1.amazonaws.com/ctal-func`, { method: "POST", body: set_body })
            .then(response => response.json())
            .then(setResult)
            .then(() => setLoading(false))
            .then(input_element.value="")
            .then(() => refresh_action_item_list())
            .catch(setError);
    }

    return (
        <>
            {user_message}
            <div class="input-group">
                <input id="new-action-item-summary" type="text" class="form-control" placeholder={new_action_placeholder} aria-label="New Action Title" aria-describedby="button-create-action-item"/>
                <button id="create-action-item-btn" class="btn btn-primary" type="button" onClick={ () => validate_and_create_action_item() }>Create</button>
            </div>
        </>
    );
}
